var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.439l-4.073 4.073a.724.724 0 01-.522.212.707.707 0 01-.532-.212.717.717 0 01-.217-.527c0-.207.072-.382.217-.527l4.494-4.494A.829.829 0 0112 8.708a.829.829 0 01.633.256l4.494 4.494c.138.138.21.313.212.522a.707.707 0 01-.212.532.717.717 0 01-.527.217.717.717 0 01-.527-.217L12 10.439z"
  })));
}
export default __webpack_public_path__ + "assets/static/media/up-arrow.167d613d.svg";
export { SvgUpArrow as ReactComponent };